import React from "react"
import { Box, Typography, styled } from "@mui/material"
import { Link } from "react-router-dom"

import { ClientManagerType } from "types"
import { colors } from "theme"

type Props = {
  manager: ClientManagerType
}

const ManagerComponent = ({ manager }: Props) => {
  return (
    <>
      {manager && (
        <Content>
          <Typography variant="body2">{manager.full_name}</Typography>
          <Phone to={`tel:${manager.phone}`}>{manager.phone}</Phone>
        </Content>
      )}
    </>
  )
}

export default ManagerComponent

const Content = styled(Box)(() => ({
  width: "100%",
}))

const Phone = styled(Link)(() => ({
  color: colors.indigo,
  fontSize: "1rem",
  fontWeight: "300",
  lineHeight: "1.6",
}))
